import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';

@Injectable({
  providedIn: 'root'
})
export class AssetService {
  private assetUrl = environment.assetUrl;

  constructor(private http: HttpClient) {}

  // ============================================
  // FORM TEMPLATE APIs
  // ============================================

  getFormTemplates(): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-form-templates/`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getFormTemplateById(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-form-templates/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  // ============================================
  // ASSET CRUD APIs
  // ============================================

  getAssets(filters?: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/assets/`;
    let params = new HttpParams();

    if (filters) {
      if (filters.limit) params = params.set('limit', filters.limit.toString());
      if (filters.offset !== undefined) params = params.set('offset', filters.offset.toString());
      if (filters.status) params = params.set('status', filters.status);
      if (filters.asset_group_id) params = params.set('asset_group_id', filters.asset_group_id);
      if (filters.asset_sub_group_id) params = params.set('asset_sub_group_id', filters.asset_sub_group_id);
      if (filters.subsidiary_id) params = params.set('subsidiary_id', filters.subsidiary_id);
      if (filters.location_id) params = params.set('location_id', filters.location_id);
      if (filters.center_id) params = params.set('center_id', filters.center_id);
      if (filters.serial_number) params = params.set('serial_number', filters.serial_number);
      if (filters.search) params = params.set('search', filters.search);
      if (filters.get_references) params = params.set('get_references', filters.get_references);
      if (filters.assigned_to_user_id) params = params.set('assigned_to_user_id', filters.assigned_to_user_id);
      if (filters.is_movable !== undefined) params = params.set('is_movable', filters.is_movable.toString());
    }

    return this.http.get<any>(url, { params, withCredentials: true });
  }

  getAsset(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/assets/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  createAssets(data: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/assets/`;
    return this.http.post<any>(url, data, { withCredentials: true });
  }

  updateAsset(id: string, data: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/assets/${id}`;
    return this.http.put<any>(url, data, { withCredentials: true });
  }

  deleteAsset(id: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/assets/${id}`;
    return this.http.delete<any>(url, { withCredentials: true });
  }

  getPrintData(assetId: string, payload: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/assets/${assetId}/print-data`;
    return this.http.post<any>(url, payload, { withCredentials: true });
  }

  // ============================================
  // ASSET HISTORY APIs
  // ============================================

  getAssetHistory(assetId: string, limit = 20, offset = 0): Observable<any> {
    const url = `${this.assetUrl}/api/v1/assets/${assetId}/history`;
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());
    return this.http.get<any>(url, { params, withCredentials: true });
  }
}
